class Colorbox {
  constructor(selector, options = {}) {
    this.settings = {
      autoPlay: false,
      ...options,
    }

    this.triggerElements = document.querySelectorAll(selector)
    this.modal = document.getElementById("colorbox-modal")
    this.modalContent = this.modal.querySelector(".colorbox-modal-content")
    this.videoContainer = this.modal.querySelector(".colorbox-video-container")
    this.closeButton = this.modal.querySelector(".colorbox-modal-close")
    this.lastFocusedElement = null

    this.attachEventListeners()
  }

  attachEventListeners() {
    this.triggerElements.forEach((element) => {
      element.addEventListener("click", this.openModal.bind(this))
    })

    this.closeButton.addEventListener("click", this.closeModal.bind(this))

    // Close modal when clicking on the backdrop
    this.modal.addEventListener("click", (event) => {
      if (event.target === this.modal) {
        this.closeModal()
      }
    })

    // Prevent clicks inside the modal content from closing the modal
    this.modalContent.addEventListener("click", (event) => {
      event.stopPropagation()
    })

    // Trap focus within the modal
    this.modalContent.addEventListener("keydown", this.trapFocus.bind(this))
  }

  openModal(event) {
    event.preventDefault()
    // Save the last focused element
    this.lastFocusedElement = document.activeElement

    const videoUrl = event.currentTarget.getAttribute("href")

    // Build the YouTube embed URL with parameters
    const params = new URLSearchParams()
    params.set("modestbranding", "1")

    if (this.settings.autoPlay) {
      params.set("autoplay", "1")
    }

    // Create iframe element for YouTube video
    const iframe = document.createElement("iframe")
    // iframe.setAttribute("src", `${videoUrl}?autoplay=1&modestbranding=1`)  Auto plays the video
    iframe.setAttribute("src", `${videoUrl}?${params.toString()}`)
    iframe.setAttribute("frameborder", "0")
    iframe.setAttribute("allow", "autoplay; encrypted-media")
    iframe.setAttribute("allowfullscreen", "")
    iframe.setAttribute("title", "YouTube video player")

    // Remove any existing iframe
    this.videoContainer.innerHTML = ""
    this.videoContainer.appendChild(iframe)

    // Show the modal
    this.modal.style.display = "flex"
    this.modal.setAttribute("aria-hidden", "false")

    // Disable background scrolling
    document.body.style.overflow = "hidden"

    // Set focus to the modal content
    this.modalContent.focus()
  }

  closeModal() {
    // Hide the modal
    this.modal.style.display = "none"
    this.modal.setAttribute("aria-hidden", "true")

    // Enable background scrolling
    document.body.style.overflow = ""

    // Remove iframe to stop the video
    this.videoContainer.innerHTML = ""

    // Return focus to the last focused element
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus()
    }
  }

  trapFocus(event) {
    const focusableElements = this.modalContent.querySelectorAll(
      'button, [href], iframe, [tabindex]:not([tabindex="-1"])',
    )

    const firstFocusableElement = focusableElements[0]
    const lastFocusableElement = focusableElements[focusableElements.length - 1]

    if (event.key === "Tab") {
      if (event.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault()
          lastFocusableElement.focus()
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault()
          firstFocusableElement.focus()
        }
      }
    } else if (event.key === "Escape") {
      this.closeModal()
    }
  }
}
